module.exports = __webpack_public_path__ + "static/tachyons.67a3f4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/tachyons.png
// module id = 858
// module chunks = 73261030922168